export const SITE_URL = "https://slnagroexports.co.in";

export const COMPANY = {
  name: "SLN Agro Exports",
  legalName: "SLN AGRO EXPORTS PRIVATE LIMITED",
  address: "10-16, Kadavakallu, Anantapur, Andhra Pradesh, India 515445",
  apeda: "[APEDA RCMC number]",
  iec: "ABTCS5702Q",
  phoneDisplay: "+91 80956 10250",
  phone: "+918095610250",
  email: "info@slnagroexports.co.in",
};

export const WHATSAPP_URL = `https://wa.me/918095610250?text=${encodeURIComponent(
  "Hello SLN Agro Exports, I would like to discuss an export order.",
)}`;

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const MONTHS_FULL = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const fmtSize = (b) => (b < 1024 ? `${b} B` : b < 1048576 ? `${Math.round(b / 1024)} KB` : `${(b / 1048576).toFixed(1)} MB`);

export const currentMonth = () => new Date().getMonth() + 1;

export function seasonStatus(product, month = currentMonth()) {
  const months = product.available_months || [];
  if (months.includes(month)) return { available: true, label: "Available now" };
  if (!months.length) return { available: false, label: "Season to be announced" };
  for (let i = 1; i <= 12; i += 1) {
    const m = ((month - 1 + i) % 12) + 1;
    if (months.includes(m)) return { available: false, label: `Next season: ${MONTHS_FULL[m - 1]}` };
  }
  return { available: false, label: "Season to be announced" };
}
